import { getTheLongestPath } from './DietSettingsTheLongestPathAction';
import { dietSettingsGetSchemaForParameters } from './DietSettingsSchemaForParametersAction';

export const getStepsCount = (steps, parameters) => {
  let result = 0;
  steps.forEach((step) => {
    result += 1;
    if (step.fork) {
      const subStepIdentifier = step.fork.chooseChild(parameters);
      if (subStepIdentifier === undefined) {
        result += getTheLongestPath([step]).length - 1;
      } else {
        const subSteps = step.fork.children[subStepIdentifier];
        result += getStepsCount(subSteps, parameters);
      }
    }
  });

  return result;
};

export const dietSettingsGetStepsCountForAllParameters = (schema, parameters) => {
  let result = 0;
  if (parameters === undefined) {
    // eslint-disable-next-line no-param-reassign
    parameters = {};
  }

  if (schema.length) {
    result = getStepsCount(schema, parameters);
  }

  return result;
};

export const dietSettingsGetStepsCountForCurrentStep = (schema, parameters, curentStep) => {
  const schemaForParameters = dietSettingsGetSchemaForParameters(schema, parameters);
  const currentStepIndex = schemaForParameters.findIndex((item) => item.id === curentStep);
  const schemaForPrevParameters = schemaForParameters.slice(0, currentStepIndex);

  const prevParameters = {};

  schemaForPrevParameters.forEach((el) => {
    prevParameters[el.id] = parameters[el.id];
  });

  return dietSettingsGetSchemaForParameters(schema, prevParameters).length;
};
